angular
  .module("AccountingBoxApp")
  .controller("ReportingCtrl", function(
    $scope,
    $http,
    $state,
    $location,
    FileUploader,
    LoopBackAuth,
    Journal,
    Rapporting,
    Sale,
    Purchase,
    BankTransaction,
    BankAccount,
    $rootScope
  ) {
    $scope.order = {
      by: "date",
      reverse: false,
      filter: ""
    };



    var vm = this;
    // vm.journals = Journal.find(
    //   { filter: { include: [{ journalLines: { include: "account" } }] } },
    //   function(journals) {
    //     console.log('journals are: ',journals);
    //   }
    // );
    var startYear = $rootScope.currentYear();
    var startDate = moment(startYear)
      .year($rootScope.currentYear())
      .startOf("year");

    $scope.defaultDateRanges = {
      "Open Boekjaar": [startDate, moment().endOf("year")],
      "Deze maand": [moment().startOf("month"), moment().endOf("month")],
      // "Vorige maand": [
      //   moment()
      //     .subtract(1, "month")
      //     .startOf("month"),
      //   moment()
      //     .subtract(1, "month")
      //     .endOf("month")
      // ],
      "1e Kwartaal": [
        moment()
          .quarter(1)
          .startOf("quarter"),
        moment()
          .quarter(1)
          .endOf("quarter")
      ],
      "T/m 2e Kwartaal": [
        moment()
          .quarter(1)
          .startOf("quarter"),
        moment()
          .quarter(2)
          .endOf("quarter")
      ],
      "T/m 3e Kwartaal": [
        moment()
          .quarter(1)
          .startOf("quarter"),
        moment()
          .quarter(3)
          .endOf("quarter")
      ]
    };
    var currentYear = moment().year();
    var yearRanges = {};
    for (var i = 0; i < 3; i++) {
      var year = currentYear - i;
      yearRanges["Jaar " + year.toString()] = [
        moment()
          .year(year)
          .startOf("year"),
        moment()
          .year(year)
          .endOf("year")
      ];
    }
    $scope.defaultDateRanges = Object.assign(
      $scope.defaultDateRanges,
      yearRanges
    );

    vm.toTransaction = function(journal) {
      var to = journal.transactionType.toLowerCase() + "s";
      if (journal.transactionType.toLowerCase() === "journalentry") {
        to = "journalEntries";
      }

      $state.go("app.company.edit." + to, {
        id: journal.transactionId
      });
    };
  });
